import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';

const serviceItems = [
    {
        id: 1,
        title: "Manage risks at portfolio level for risk mitigation",
        description: "Identify, assess, and control cross-project dependencies and strategic risks early to safeguard enterprise deliverables and budget adherence.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Monitor project performance to take corrective actions",
        description: "Track milestones, budget burn rates, and resource allocations in real time to proactively resolve issues before they escalate.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Improved visibility into project performance",
        description: "Consolidate portfolio metrics and reporting into centralized executive dashboards to drive informed, data-backed strategic decisions.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];

const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "Our PPM experts assess your current portfolio, project, and resource management maturity. We identify visibility gaps, prioritization challenges, and execution bottlenecks, then define a clear roadmap aligned to your strategic goals, operating model, and governance needs.",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We deliver structured ServiceNow PPM implementations that fit your business needs. From demand intake and portfolio prioritization to project delivery, resource management, and financial tracking, we ensure rapid adoption, measurable value, and seamless integration with ITSM, Agile, and Finance processes.",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "Our engagement extends beyond go-live. We provide continuous support, enhancements, and optimization to help your PPM platform evolve with changing priorities, growing portfolios, and increasing delivery complexity.",
        products: []
    },
    {
        id: 4,
        title: "Resource Augmentation",
        desc: "Scale your PPM team with the right expertise, exactly when you need it. Aelum provides certified ServiceNow PPM professionals on demand, whether you need short-term project support or a dedicated risk operations pod.",
        products: []
    }
];


const industryTabs = [
    {
        id: "it-operations",
        label: "IT Operations",
        title: "IT Operations",
        desc: "Leverage Predictive Intelligence to proactively identify and resolve issues, minimizing downtime and enhancing service reliability.[cite: 27]",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "customer-service",
        label: "Customer Service",
        title: "Customer Service",
        desc: "Deploy Virtual Agents to provide instant, 24/7 support, reducing case volumes and improving customer satisfaction.[cite: 27]",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "human-resources",
        label: "Human Resources",
        title: "Human Resources",
        desc: "Automate onboarding, manage employee inquiries, and personalize HR services, fostering a more engaged workforce.[cite: 27]",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "security-operations",
        label: "Security Operations",
        title: "Security Operations",
        desc: "Utilize AI-driven analytics to detect threats, automate incident responses, and maintain robust security postures.[cite: 27]",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: "finance-procurement",
        label: "Finance and Procurement",
        title: "Finance and Procurement",
        desc: "Streamline invoice processing and procurement workflows through intelligent automation, enhancing accuracy and efficiency.[cite: 27]",
        image: "/assets/mumbai/item2.png",
        link: "#"
    },
    {
        id: "facilities-management",
        label: "Facilities Management",
        title: "Facilities Management",
        desc: "Optimize space utilization and maintenance schedules with AI-powered insights, ensuring operational excellence.[cite: 27]",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Unified Service Delivery",
        desc: "Unified service delivery across IT, HR, Facilities, and Finance"
    },
    {
        id: 2,
        title: "Scalable Workflows",
        desc: "Standardized, scalable workflows that boost operational consistency"
    },
    {
        id: 3,
        title: "Built-In Governance",
        desc: "Service governance and compliance built into every implementation"
    },
    {
        id: 4,
        title: "Actionable Insights",
        desc: "Actionable insights to improve performance and decision-making"
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What is the difference between ITSM and ESM?",
        answer: "ITSM focuses on IT service delivery, while ESM extends service management practices across HR, finance, facilities, and other departments for enterprise-wide efficiency."
    },
    {
        id: 2,
        question: "Why choose ESM for department-specific tools?",
        answer: "ESM eliminates silos, standardizes processes, improves visibility, and delivers consistent, automated services across the organization."
    },
    {
        id: 3,
        question: "How does Aelum ensure a smooth transition to ESM?",
        answer: "Aelum assesses workflows, aligns processes, and implements ServiceNow ESM with minimal disruption, guided by practitioner-led expertise and best practices."
    },
    {
        id: 4,
        question: "Can ServiceNow ESM integrate with legacy systems?",
        answer: "Yes. ServiceNow ESM supports integration with existing enterprise systems, ensuring seamless data flow and unified service delivery."
    },
    {
        id: 5,
        question: "How do Aelum’s Pod services support ESM?",
        answer: "Our Pods embed certified experts within your teams, providing ongoing support, optimization, and adoption guidance for scalable, efficient enterprise service operations."
    }
];


const expectItems = [
    "Unified Enterprise Service Portal",
    "Standardized Service Catalogs",
    "Automated Cross-Department Workflows",
    "Self-Service and Virtual Agent Experiences",
    "Performance Analytics and Service Insights"
];


function ImplementationPartner() {
    return (
        <div>
            <WhoHero
                title="ServiceNow PPM Implementation Partner"
                text="Connect strategy to execution by aligning portfolios, resources, and delivery in one platform."
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Your productivity with ServiceNow AI" description="The AI era is advancing faster than we ever imagined, quickly becoming the driving force behind modern enterprises—fuelling progress with every insight and breakthrough. The real advantage lies in how efficiently and effectively an organization delivers value to both its customers and employees. To make impossible possible, businesses need a trusted partner like Aelum Consulting to shape and implement AI solutions that carve out a unique, transformative path. With the power of ServiceNow AI, we connect and automate workflows across your entire enterprise, unifying AI, data, and processes on a single, intelligent platform. This seamless integration not only streamlines operations but also empowers your teams to focus on what truly matters—driving growth and delivering exceptional value." /> */}
            <ServiceX360ViewSection title="Align and manage connected, interrelated, and dependent projects, programs, & programs with ServiceNow PPM" description="Move from fragmented project tracking to strategic, data-driven portfolio execution with ServiceNow PPM. Aelum helps enterprises unify demand, programs, projects, resources, and financials on a single platform, giving leaders real-time visibility into what work is happening, why it matters, and how it’s performing. Our certified PPM experts implement solutions that manage your projects by evaluating and prioritizing them based on alignment with your strategic goals, available resources, and potential benefits. You get better prioritization, optimized resource utilization, predictable delivery without manual reporting, or disconnected tools. " serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow PPM Services" description="End-to-end support to implement, optimize, and scale enterprise portfolio execution with ServiceNow" />
            <WhatToExpectSection title="What to expect from ServiceNow PPM" description="" expectItems={expectItems} />
            <WeCanAlsoHelpWithSection />
            {/* <IndustriesServiceExperienceSection title="ServiceNow AI for Every Corner of Your Business" industryTabs={industryTabs} /> */}
            <WhatSetsApartSection title="Why Mobikode for ServiceNow Enterprise Service Management?" description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default ImplementationPartner
